export class BaseAnalyticsService {
  logEvent(eventName: string, eventParams?: Record<string, any>) {
    console.warn(
      'logEvent called on BaseAnalyticsService. This should be overridden in a subclass.',
      eventName,
      eventParams,
    );
  }
}

export const baseAnalyticsService = new BaseAnalyticsService();
